import React from 'react'

const H2HIcon = ({ fill, width, height }) => (
  <svg
    width={width || '32'}
    height={height || '19'}
    viewBox="0 0 32 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.1306 8.79248C18.1306 8.79248 18.0354 16.7589 23.3552 17.1112C28.674 17.461 32 11.0186 32 11.0186C32 11.0186 18.7952 9.37958 18.1306 8.79248"
      fill={fill || '#004360'}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.0806198 0.587891C0.0806198 0.587891 12.6188 1.2912 18.1291 0.587891C18.1291 0.587891 13.7586 14.2934 22.0234 18.2748C22.0234 18.2748 17.0836 18.9793 12.8083 18.2748C8.53398 17.5715 -0.965866 14.8793 0.0806198 0.587891"
      fill={fill || '#004360'}
    />
  </svg>
)

export default H2HIcon
